module.exports = __webpack_public_path__ + "images/application/i-checkmark-white-1b6e5df2.svg";